import { Component, EventEmitter, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { UbiFilterService } from '../../../theme';

import { DynamicGridComponent } from '../../../dynamic-entity/components/dynamic-grid/dynamic-grid.component';

import { ApiService, MetadataService, ExpressionFilter, ExpressionRule, Operator, Condition } from '../../../ubi-core/ubi-core.module';
import { LocalizedDatePipe } from '../../../ubi-core/pipes/LocalizedDatePipe';

@Component({
  selector: 'app-announcementItems',
  templateUrl: './announcementItems.component.html',
  styleUrls: ['./announcementItems.component.scss']
})
export class AnnouncementItemsComponent extends DynamicGridComponent implements OnInit {

  @ViewChild('hdrTpl') hdrTpl: TemplateRef<any>;
  @ViewChild('statusTmpl') statusTmpl: TemplateRef<any>;

  protected columns = [];

  constructor(protected baseservice: ApiService, protected metadataservice: MetadataService,
    protected router: Router, protected route: ActivatedRoute, protected modalService: NgbModal,
    protected filterservice: UbiFilterService) {

    super(baseservice, metadataservice, router, route, modalService, filterservice);

  }

  ngOnInit() {
    super.ngOnInit();
  }

  protected getMetadata() {

    this.columns = [
      {
        prop: 'StatusID', name: 'Anúncio', width: 49, canAutoResize: false, draggable: false,
        resizeable: false, headerTemplate: this.hdrTpl, cellTemplate: this.statusTmpl
      },
      { prop: 'ProductCode', name: 'Código' },
      { prop: 'ProductName', name: 'Produto' },
      { prop: 'Announcement.Type.Designation', name: 'Tipo Anúncio' },
      { prop: 'Announcement.VesselAndProcess.Designation', name: 'Navio' },
      { prop: 'Announcement.VesselAndProcess.Process', name: 'Contramarca' },
      { prop: 'Lot', name: 'Lote' },
      { prop: 'ProductType.Designation', name: 'Tipo de Produto' },
      { prop: 'CreatedOn', name: 'Criado em', pipe: new LocalizedDatePipe('pt-PT', 'yyyy/MM/dd hh:mm') }
    ];

    this.columns = [...this.columns];
  }

  protected getInitialData() {

    this.page.sorts = [{ prop: 'Id', dir: 'desc' }];

    // this.filter = new ExpressionFilter(Condition.AND);

    // this.filter.addRule(new ExpressionRule('Announcement.TypeID', Operator.Equal, 1));
    // //this.filter.addRule(new ExpressionRule('ProductCode', Operator.Not_Equal, '870575274'));

    // //this.filter = JSON.parse('{"condition":"AND","rules":[{"field":"Id","operator":"less_or_equal","value":4}]}');

    // let a = { condition: 'AND', rules: [{ field: 'Id', operator: 'less_or_equal', value: 4 }] };
    // var myFilter = new ExpressionFilter(Condition.AND).deserialize(a);

    // console.log(myFilter);

    this.getPage({ offset: 0 }, this.filter);
  }

  public newClick(event) {
    this.router.navigateByUrl(this.navigateUrl);
  }


  public openDetail({ selected }) {
    if (this.navigateUrl !== null && this.navigateUrl !== undefined) {
      this.router.navigateByUrl(this.navigateUrl + '/' + selected[0].Announcement.Id);
    }
  }

}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/base/backoffice/announcementItems/announcementItems.component.ts